import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { RatingsSchema } from '../schemas/ratings';

type UseUpdateEstateRatings = {
  mutationConfig?: MutationConfig<typeof updateEstateRating>;
};

export interface UpdateEstateRatings extends Record<keyof RatingsSchema, number> {
  id: string;
}

export const updateEstateRating = ({ id, ...args }: UpdateEstateRatings) => {
  return extractData(api.estates({ id }).ratings.put({ ...args }));
};

export const useUpdateEstateRatings = ({ mutationConfig }: UseUpdateEstateRatings) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: updateEstateRating,
  });
};
